// AUTO-GENERATED by tools/codegen (pnpm gen). Do not edit. Source: apps/client/src/game/testFinders/*.ts
import * as m0 from './testFinders/core';
import * as m1 from './testFinders/digging';
import * as m2 from './testFinders/fishing';
import * as m3 from './testFinders/items';
import * as m4 from './testFinders/museum';
import * as m5 from './testFinders/nature';
import * as m6 from './testFinders/shop';
import * as m7 from './testFinders/villagers';
export const testFinderModules = [m0, m1, m2, m3, m4, m5, m6, m7] as const;
